import React from "react";
import { SectionLabelComponent } from "./SectionLabel/SectionLabel";
import { useSettings } from "../../../hooks/useSettings";
import { SectionInterface } from "../../../store/types/store";
import useButtonPosition from "../../../hooks/useButtonPosition";
import { useShelvingStore, useStoreSystem } from "../../../store";
import shallow from "zustand/shallow";


interface SectionSizesProps {
    camera: any;
    canvasSize: any;
}

export const SectionSizes: React.FunctionComponent<SectionSizesProps> = ({ canvasSize, camera }): any => {
    const calcPosition = useButtonPosition('middle');

    const { getCurrentShelving, shelving } = useShelvingStore((state) => ({
        getCurrentShelving: state.getCurrentShelving,
        shelving: state.shelving,
    }), shallow);
    const { currentSectionId } = useStoreSystem(state => ({
        currentSectionId: state.currentSectionId,
    }));

    const sections = getCurrentShelving().sections;

    const { isVisibleSizes } = useSettings();

    if (!isVisibleSizes) {
        return null
    }
    // useFrame(() => {})

    if (sections.length > 0 && camera && canvasSize) { //TODO взял как было, но мельников брал labels, в этом есть смысл. Хотя  labels - вообще вспомогательный элемент и смысл его хранить в стейте??? его можно генерировать
        return sections?.map((section: SectionInterface) => {
            return (
                <SectionLabelComponent
                    value={section.width}
                    key={`${section.id}`}
                    pos={calcPosition(section, null)}
                    camera={camera}
                    canvasSize={canvasSize}
                    type={"info"}
                    id={""}
                />
            );
        });
    }

    return null
}
